import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {textHandle} from 'presentation/utils/textHandle';
import {DataContentCard} from '../../../../components/DataContentCard';
import {StyledCard, StyledDataContent, StyledHeaderContainer, StyledTitle} from './styles';
import {PrescriptionsCardType} from './types';

const {requestDate} = translations['pt-br'].privateFlow.myHospitalization.prescriptions.card;

export const PrescriptionsCard = ({prescription, dataTestId}: PrescriptionsCardType) => (
	<StyledCard data-test-id={dataTestId}>
		<StyledHeaderContainer>
			<StyledTitle variant="h6">
				{textHandle(prescription.medicationName.toLowerCase()).capitalize()}
			</StyledTitle>
			<Typography>
				{prescription.dosage} de {prescription.frequency}
			</Typography>
		</StyledHeaderContainer>
		<StyledDataContent>
			<DataContentCard
				iconName="query-builder-filled"
				title={requestDate}
				description={`${prescription.prescriptionDate} às ${prescription.prescriptionTime}`}
			/>
		</StyledDataContent>
	</StyledCard>
);
